import Breadcrumb from "components/Common/Breadcrumb"
import { Button, Card, CardBody, Container, Input, Table } from "reactstrap"
import React, { useEffect, useMemo, useState } from "react"
import Loader from "components/Loader/loader"
import {
  FaChevronCircleLeft,
  FaChevronCircleRight,
  FaClock,
  FaEye,
  FaPen,
  FaPlus,
  FaSearch,
} from "react-icons/fa"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import { FaCircleCheck } from "react-icons/fa6"
import { MdDelete } from "react-icons/md"
import { usePermissionData } from "AppContext"
import TemplateModal from "./contractModal"
import Swal from "sweetalert2"

const Contract = () => {
  const { checkAccess } = usePermissionData()

  const [loading, setLoading] = useState(false)

  const [contractModal, setContractModal] = useState(false)
  const [selectedTemplate, setSelectedTemplate] = useState({})

  const [modalType, setModalType] = useState("")

  const [perPageItem, setPerPageItem] = useState(10)
  const [searchString, setSearchString] = useState("")
  const [currentPage, setCurrentPage] = useState(1)

  const [templates, setTemplates] = useState([])

  useEffect(() => {
    getTemplates()
  }, [])

  async function getTemplates() {
    const APIData = await fetchData(setLoading, "template")

    if (APIData?.data) {
      setTemplates(APIData?.data?.reverse())
    }
  }

  const filteredTemplates = useMemo(() => {
    return templates.filter(loc =>
      loc.name.toLowerCase().includes(searchString.toLowerCase())
    )
  }, [templates, searchString])

  const totalPages = Math.ceil(filteredTemplates.length / perPageItem)

  const paginatedTemplates = useMemo(() => {
    const start = (currentPage - 1) * perPageItem
    return filteredTemplates.slice(start, start + perPageItem)
  }, [filteredTemplates, currentPage, perPageItem])

  const toggleModal = () => setContractModal(!contractModal)

  const handleChange = e => {
    const { name, value } = e.target
    setSelectedTemplate(prev => ({ ...prev, [name]: value }))
  }

  const handleSave = async () => {
    if (selectedTemplate.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "template",
        selectedTemplate.id,
        selectedTemplate
      )
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Success",
          text: "Contract Template Updated Successfully",
          icon: "success",
        })
        getTemplates()
      } else {
        Swal.fire({
          title: "Something Went Wrong",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(
        setLoading,
        "template",
        selectedTemplate
      )
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Success",
          text: "Contract Template Added Successfully",
          icon: "success",
        })
        getTemplates()
      } else {
        Swal.fire({
          title: "Something Went Wrong",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
    toggleModal()
  }

  const handleDelete = async (id, name) => {
    const result = await Swal.fire({
      title: "Are You Sure?",
      text: `You want to delete ${name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3d6eb6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it",
    })

    if (result.isConfirmed) {
      try {
        const APIdata = await FetchDeleteData(setLoading, "template", id)

        if (APIdata?.data) {
          await Swal.fire({
            title: "Contract Template Deleted Successfully.",
            icon: "success",
          })
          getTemplates()
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIdata?.response?.data?.message || "Please try again later.",
            icon: "error",
          })
        }
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err?.message || "Failed to delete location.",
          icon: "error",
        })
      }
    }
  }

  return (
    <div className="page-content">
      {/* <PermittedComponent isAccess={checkAccess(5, 1) || checkAccess(5, 2)}> */}
      <Container fluid>
        <Breadcrumb
          title="Settings"
          breadcrumbItem="Template"
          description="Manage the all location Contract Templates from here"
        />
        {loading && <Loader />}
        <Card className="mb-0 shadow-lg">
          <CardBody>
            {/* Header Controls */}
            <div className="d-flex justify-content-between">
              <div className="d-flex gap-3">
                <select
                  className="form-select rounded-4 ps-3 pe-5 w-auto"
                  value={perPageItem}
                  onChange={e => {
                    setPerPageItem(Number(e.target.value))
                    setCurrentPage(1)
                  }}
                >
                  <option value={10}>Show 10</option>
                  <option value={20}>Show 20</option>
                  <option value={50}>Show 50</option>
                </select>

                <div className="position-relative">
                  <input
                    className="form-control rounded-4 px-3 pe-5"
                    placeholder="Search Template"
                    value={searchString}
                    onChange={e => setSearchString(e.target.value)}
                  />
                  <span className="position-absolute end-0 top-50 translate-middle-y pe-3 text-muted">
                    <FaSearch />
                  </span>
                </div>
              </div>

              {checkAccess(5, 3) && (
                <div className="d-flex gap-3">
                  <Button
                    className="btn-blue"
                    onClick={() => {
                      setSelectedTemplate({})
                      toggleModal()
                      setModalType("")
                    }}
                  >
                    <FaPlus className="me-2" /> Template
                  </Button>
                </div>
              )}
            </div>

            {/* Location Table */}
            <div className="mt-5">
              <Table responsive hover>
                <thead className="bg-blue text-white">
                  <tr>
                    <th>#</th>
                    <th>Template Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedTemplates.length > 0 ? (
                    paginatedTemplates.map((loc, index) => (
                      <tr key={loc.id}>
                        <td>{(currentPage - 1) * perPageItem + index + 1}</td>
                        <td>{loc.name}</td>

                        <td className="d-flex flex-nowrap">
                          <Button
                            size="sm"
                            className="me-2 btn-blue"
                            onClick={() => {
                              setSelectedTemplate(loc)
                              toggleModal()
                              setModalType("view")
                            }}
                          >
                            <FaEye size={14} />
                          </Button>
                          {checkAccess(5, 4) && (
                            <Button
                              color="success"
                              size="sm"
                              className="me-2"
                              onClick={() => {
                                setSelectedTemplate(loc)
                                toggleModal()
                                setModalType("")
                              }}
                            >
                              <FaPen size={14} />
                            </Button>
                          )}
                          {checkAccess(5, 5) && (
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleDelete(loc.id, loc.name)}
                            >
                              <MdDelete size={14} />
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center text-muted">
                        No Templates found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-between  gap-2">
              <p className="mb-0">
                Showing {paginatedTemplates.length} out of {templates.length}{" "}
                Templates.
              </p>
              <div>
                <Button
                  size="sm"
                  disabled={currentPage === 1}
                  className="fs-6"
                  onClick={() => setCurrentPage(prev => prev - 1)}
                >
                  <FaChevronCircleLeft />
                </Button>
                {Array.from({ length: totalPages }, (_, i) => (
                  <Button
                    key={i}
                    size="sm"
                    className="mx-2 fs-6"
                    color={currentPage === i + 1 ? "primary" : "light"}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </Button>
                ))}
                <Button
                  size="sm"
                  className="fs-6"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(prev => prev + 1)}
                >
                  <FaChevronCircleRight />
                </Button>
              </div>
            </div>
          </CardBody>
        </Card>
      </Container>
      <TemplateModal
        isOpen={contractModal}
        toggle={toggleModal}
        templateData={selectedTemplate}
        setTemplateData={setSelectedTemplate}
        onChange={handleChange}
        onSave={handleSave}
        type={modalType}
      />
      {/* </PermittedComponent> */}
    </div>
  )
}

export default Contract
